export default "__VITE_ASSET__DusxCtvr__"